import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const tines = defineConnector({
  identifier: "tines",
  name: "Tines Stories",
  tagLine: "Intelligent workflow platform",
  keywords: "stories cases records",
  aiContext: "Also provides access to Tines Cases and Tines Records",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.tines\\.(com|io)/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In your Tines tenant, navigate to your profile icon and select **API**. Generate a new API token and copy it.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Tines URL",
          required: true,
          placeholder: "yourcompany.tines.com",
          target: { kind: "configuration", field: "url" },
          helperText: "Your Tines tenant URL",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  publicEnvVars: ({ url }): Record<string, string> => {
    if (url) {
      return { TINES_URL: `https://${url}` };
    }
    return {};
  },
  connectionTest: {
    protocol: "http",
    request: ({ url }) => `https://${url}/api/v1/info`,
  },
  usageHint: () =>
    "Tines Stories API docs: https://www.tines.com/docs/api/llms.txt",
});
